'use strict';/* global define, console */define('modules/integrations/services/user-imports/index',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Return the ngResource object
   * for the user imports service
   */// @ngInject
     factory.$inject = ["$resource", "Cancelator", "API_ENDPOINT", "IMPORTED_ITEMS_TYPES", "_"];
function factory($resource,Cancelator,API_ENDPOINT,IMPORTED_ITEMS_TYPES,_){// jshint validthis:true
// jshint latedef:false
var userImportsBaseUrl=API_ENDPOINT+'userimports';var userImportsUrl=userImportsBaseUrl+'/:id';var UserImports=$resource(userImportsUrl,{id:'@id'},{create:{url:userImportsBaseUrl+'/integration/:integrationId',params:{integrationId:'@integrationId'},method:'POST'},execute:{url:userImportsUrl+'/execute',method:'POST'},restore:{url:userImportsUrl+'/restore',method:'POST'},cancel:{url:userImportsUrl+'/cancel',method:'POST'},getProgress:{url:userImportsUrl+'/progress',method:'GET',ignoreLoadingBar:true},updateActions:{url:userImportsBaseUrl+'/actions/:actionId',params:{actionId:'@actionId'},method:'PATCH'},confirmAllActions:{url:userImportsUrl+'/actions',method:'PATCH'},getSelectionMetrics:{url:userImportsUrl+'/selection-status',method:'GET'}});return{get:UserImports.get,delete:UserImports.delete,create:UserImports.create,execute:UserImports.execute,restore:UserImports.restore,cancel:UserImports.cancel,getProgress:UserImports.getProgress,getImports:getImports,getItems:getItems,updateActions:UserImports.updateActions,confirmAllActions:UserImports.confirmAllActions,getSelectionMetrics:UserImports.getSelectionMetrics,getImportByStatusName:getImportByStatusName,getRunningImport:getRunningImport,mapImportItemsStatus:mapImportItemsStatus};// ---
/**
     * Get user import items
     *
     * @param  {Object} params - Additional parameters
     *
     * @return {Object}        - Promise object
     */function getItems(params){var resource=Cancelator.createResource(userImportsUrl+'/items',{},{get:{method:'GET'}});return resource.get(params);}/**
     * Get all available imports
     *
     * @param  {Object|Undefined} params - Additional parameters
     *
     * @return {Object}                  - Promise object
     */function getImports(params){var resource=Cancelator.createResource(userImportsUrl,{},{get:{method:'GET'}});return resource.get(params);}/**
     * Get import object by provided status name
     *
     * @param  {Array} imports     - Collection of available imports
     * @param  {String} statusName - The name of the requested status
     *
     * @return {Object}            - The import object matching the criteria
     */function getImportByStatusName(imports,statusName){return _.find(imports,function(importObj){return importObj.statusName===statusName;});}/**
     * Get running import object if any.
     * Running includes: new, fetching, pending, and processing
     *
     * @param  {Array} imports     - Collection of available imports
     *
     * @return {Object}            - The import object that is running
     */function getRunningImport(imports){return _.find(imports,function(importObj){return[1,2,3,7,8].indexOf(importObj.status)>-1;});}/**
     * Map imported items to the expected status types
     *
     * @param  {Array} items - Collection of imported items
     *
     * @return {Array}       - Updated items with the corresponding
     *                         import stats
     *
     * @tested
     */function mapImportItemsStatus(items){return _.map(items,_checkImportItemsStatus);}/**
     * Helper function to check and assign status
     * for each imported item
     *
     * @param  {Object} item - Single import item
     *
     * @return {Object}      - The updated import item with
     *                         the importStatus property
     *
     * @private
     */function _checkImportItemsStatus(item){if(item.unsolvableIssues.length>0||item.solvableIssues.length>0){item.importStatus='error';return item;}_.forIn(IMPORTED_ITEMS_TYPES,function(config,status){return!_.some(config.possibleActions,function(possibleAction){if(!!item.actions[possibleAction]&&item.actions[possibleAction].resultName===config.resultName){item.importStatus=status;return true;}return false;});});return item;}}module.exports=factory;});
